import { type SapAdapterRouter } from '@backend-types/AppRouter';
import { type inferRouterInputs, type inferRouterOutputs } from '@trpc/server';

type SapAdapterOutputs = inferRouterOutputs<SapAdapterRouter>;
type SapAdapterInputs = inferRouterInputs<SapAdapterRouter>;

export type UpcomingVeranstaltung = SapAdapterOutputs['veranstaltung']['getUpcomingVeranstaltungen'][number];
export type VaSearchInput = SapAdapterInputs['veranstaltung']['getVeranstaltungenSearch'];
export type VeranstaltungFromSearch = SapAdapterOutputs['veranstaltung']['getVeranstaltungenSearch'][number];
export type TopicVeranstaltung = SapAdapterOutputs['veranstaltung']['getTopicVeranstaltung'][number];

export type Geschaeftsbereich = VeranstaltungFromSearch['geschaeftsbereich'];

export const geschaeftsbereiche = {
  CAS: 'CAS',
  DLS: 'DLS',
  ILS: 'ILS',
  IHC: 'IHC',
  KFF: 'KFF',
  UNKNOWN: 'UNKNOWN',
} as const satisfies Record<string, Geschaeftsbereich>;

export type SapStatus = UpcomingVeranstaltung['status'] & {};

export const sapStatus = {
  ABGESAGT: 'abgesagt',
  GEPLANT: 'geplant',
  FIXIERT: 'fixiert',
  GESPERRT: 'gesperrt',
} satisfies Record<string, SapStatus>;

export type Veranstaltung = SapAdapterOutputs['veranstaltung']['getVeranstaltungBySapId'];
export type ZoomMeetingInfo = ((Veranstaltung['virtualclassroom'] & {})['details'] & {})[number];

export const klassifizierung = {
  DURCHGANG: 'Durchgang',
  MODULTERMIN: 'Modultermin',
  TERMINIERT: 'Terminierte Veranstaltung',
  UNBEKANNT: 'Unbekannt',
} satisfies Record<string, Veranstaltung['klassifizierung']>;

type NonNullableAnbieter = NonNullable<Veranstaltung['anbieter']>;
export const anbieter: Record<NonNullableAnbieter, string> = {
  AKA: 'Haufe Akademie',
  DIGI: 'Digicomp',
  STACK: 'Stackfuel',
  ITECH: 'iTech Progress',
};
